<template>
	<div>
		<a-modal v-show='!ishand' id='my_warp' width='40rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top: 30 +'vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;">
					添加邀請人
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;left: -.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='left' layout='vertical' :rules='rules'
						hideRequiredMark>
						<a-row>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item prop='number' label='證券帳號'>
									<div v-if='itemobj.inviterid'>{{form.number}}</div>
									<a-input v-model="form.number" :maxLength='7' v-else
									 @input="handitems" 
									/>
								</a-form-model-item>
							</a-col>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item prop='name' label='邀請人姓名'>
									<a-input v-model="form.name"  />
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item label='邀請人編號' prop='inviterid'>
									<div style="text-align: left;font-size: .8rem;">
										{{form.inviterid}}
									</div>
								</a-form-model-item>
							</a-col>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item prop='status' label='邀請狀態'>
									<div style='width:80%'> 
											<a-radio-group v-model="form.status">
												<a-radio :value="1">使用中</a-radio>
												<a-radio :value="2">已暫停</a-radio>
											</a-radio-group>
									</div>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
					<div style="text-align: center;">
						<button class='btn1 btnx' @click='handitem("form")' v-html='"保&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;存"'></button>
						<!-- <button class='btn1 btn2' @click='resetForm("form")'>取消開戶</button> -->
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['itemobj'],
		data() {
			return {
				loading:true,
				ishand: false,
				visible: true,
				rules: {
					status: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					number: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				form: {
					"token":"",
					 "inviterid":"",
					 "name":"",
					 "number":"",
					 "status":''
				},
			}
		},
		mounted() {
			console.log(this.itemobj)
			this.form.inviterid = this.itemobj.inviterid||''
			this.form.name = this.itemobj.name||''
			this.form.number = this.itemobj.number||''
			this.form.status = this.itemobj.status||''
			// this.handz()
		},
		methods: {
			handitems(){
				this.form.number = this.form.number.replace(/[^\d]/g, '')
				if(this.form.number.length==7){
					this.form.inviterid = 'QMIS' + this.form.number.slice(3,7)
				} 
			},
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getRevis,
					data: {
						"nationcode": this.itemobj.nationcode,
						"phonenum": this.itemobj.phonenum,
						'khcreatedate': this.itemobj.khcreatedate,
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(ruleForm) {
				// if(this.loading){
					// this.loading = false
				// this.$refs[ruleForm].resetFields();
			},
	
			handitem(ruleForm) {
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						this.form.token = this.$store.state.token;
						if(!this.itemobj.inviterid){
							this.form.flag = 'new'
						}
						this.$ajax({
							method: 'post',
							url: this.$api.editKh,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					} else {
						return false;
					}
				});
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#my_warp .ant-modal-header,
	#my_warp .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#my_warp {
		.ant-form-explain{
			display: none;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #ed4849;
		}
	}
</style>
